<template>
  <v-content id="home" >
    <banner style="margin-bottom:2rem;"/>

    <router-view class="mx-auto text-left" align="justify" style="margin-bottom:2rem;"/>
  </v-content>
</template>

<script>
  export default {
    name: 'CoreView',

    components: {
      Banner: () => import('@/components/core/Banner'),
    },
  }
</script>
